module.exports = __webpack_public_path__ + "img/logo.acc6528b.gif";